import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";
import { connect } from "redux-vue";
import * as moduleActions from "../actions/module";
import LoadingIndicator from "../components/LoadingIndicator";

const QuickviewModal = modalPageDecorator({
  props: ["user", "module", "modules", "setModule", "enrollModule"],

  watch: {
    /**
     *
     * @param nextVal
     * @param val
     */
    modules(nextVal, val) {
      if (val.fetch && nextVal.fetchSuccess) {
        const module = this.modules.collection.find(i => i.id == this.$route.params.id);
        if (module) {
          this.setModule(module);
        }
      }
    },

    /**
     *
     * @param nextVal
     * @param val
     */
    module(nextVal, val) {
      if (val.enroll && nextVal.enrollSuccess) {
        this.dismiss();
      }
    }
  },

  methods: {
    /**
     *
     * @param row
     * @returns {Function}
     */
    onPressEnroll (row) {
      return () => {
        const isAuthorized = !!(this.user.token && this.user.model);

        if (!isAuthorized) {
          this.$router.push({name: 'RegisterModal'});
        } else {
          const hasActivity = (row.lessons || [])
            .some(lesson => !!lesson.activities.length);
          if (hasActivity) {
            this.enrollModule(row);
          } else {
            Snackbar.show({
              text: this.$t('courses_page.module_available_soon'),
              actionText: this.$t('dismiss'),
            });
          }
        }
      }
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const model = this.module.model;

    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container p-12 md:max-w-6xl mx-auto rounded shadow-lg relative z-50">

            <div onClick={this.dismiss} class="cursor-pointer z-50 absolute top-0 right-0 m-5">
              <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
            </div>
            
            {!!!model && <LoadingIndicator fill="#000" class="mx-auto transform scale-150"/>}

            {!!model && (
              <fragment>
                <div class="">
                  <small class="text-gray-700">
                    {this.$t('courses_page.course_sequence', {sequence: model.sequence})}
                  </small>
                  <h2 class="text-2xl lg:text-3xl font-bold my-2">
                    {model.name}
                  </h2>
                </div>

                <div class="flex flex-wrap mb-5 lg:mb-0">
                  <div class="w-full lg:w-6/12">
                    <p class="py-3 font-bold text-base">
                      {model.description}
                    </p>
                    <p class="text-base text-gray-700 mb-10" domPropsInnerHTML={model.summary}></p>
                    <p class="py-3 font-bold text-base">
                      {this.$t('courses_page.estimated_time')}
                    </p>
                    <p class="text-base text-gray-700 mb-10">
                      {model.estimated_time}
                    </p>
                  </div>
                  <div class="w-full lg:w-5/12 lg:ml-auto">
                    <p class="py-3 font-bold text-base">
                      {this.$t('courses_page.lessons')}
                    </p>
                    <div class="bg-gray-200 overflow-y-auto flex-1 max-h-350px -mx-6 lg:mx-0 p-6 lg:p-3">
                      {model.lessons.map(lesson => (
                        <fragment key={lesson.id}>
                          <p class="font-bold mb-2 text-gray-700">
                            {lesson.name}
                          </p>
                          <ul class="text-gray-700 list-disc list-inside pl-6 mb-3">
                            {lesson.activities.map(activity => (
                              <li key={activity.id}>{activity.name}</li>
                            ))}
                          </ul>
                        </fragment>
                      ))}
                    </div>
                  </div>
                </div>

                <button
                  class="mb-3 lg:mb-0 px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                  type="button" onClick={this.onPressEnroll(model)} disabled={this.module.enroll}>
                  {this.module.enroll && this.module.model.id == this.$route.params.id
                    ? <LoadingIndicator/>
                    : (
                      <fragment>
                        {this.$t('courses_page.enroll_now')}
                        <i class="mdi mdi-arrow-right ml-5"></i>
                      </fragment>
                    )
                  }
                </button>
              </fragment>
            )}
          </div>
        </div>
      </ModalTemplate>
    )
  }
});

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
    modules: state.modules,
  };
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(QuickviewModal);